<app-user-audit-step
	*ngIf="activeStep; else userAuditDisabled"
	[translation]="currentTranslation"
	[stepNumber]="activeStep"
	(auditActionPerformed)="onAuditAction()"
></app-user-audit-step>

<ng-template #userAuditDisabled>
	<h1 [innerHtml]="'UserAudit.UserAuditDisabled' | translate"></h1>
</ng-template>